import React from 'react'

const VERSION = process.env.REACT_APP_VERSION || require('../../package.json').version
const BUILD_TIME = process.env.REACT_APP_BUILD_TIME || 'dev-mode'
const IS_DEV = process.env.NODE_ENV === 'development'

interface VersionInfoProps {
  position?: 'bottom-right' | 'bottom-left' | 'inline'
  className?: string
}

export default function VersionInfo({ 
  position = 'bottom-right', 
  className = '' 
}: VersionInfoProps) {
  const positionClasses = {
    'bottom-right': 'fixed bottom-4 right-4',
    'bottom-left': 'fixed bottom-4 left-4', 
    'inline': ''
  }

  const baseClasses = position === 'inline' 
    ? 'text-xs text-gray-500'
    : 'bg-white/80 backdrop-blur-sm border border-gray-200 rounded-lg px-3 py-2 shadow-sm'

  return (
    <div className={`${positionClasses[position]} ${baseClasses} ${className}`}>
      <div className="text-xs text-gray-500 space-y-1">
        <div>v{VERSION}</div>
        <div title={BUILD_TIME}>
          {IS_DEV ? 'Development Mode' : `${new Date(BUILD_TIME).toLocaleDateString()} ${new Date(BUILD_TIME).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`}
        </div>
      </div>
    </div>
  )
}